import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const NoEncryptionGmailerrorredIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"no_encryption_gmailerrorred"} ref={ref}/>
});

NoEncryptionGmailerrorredIcon.displayName = "NoEncryptionGmailerrorredIcon";
